import {AbstractBaseComponent} from './abstract-base.component';
import {inject, Injectable} from '@angular/core';
import {PAGE} from '@shared/di/page.token';
import {JwtService} from '../services/jwt.service';

@Injectable()
export abstract class AbstractPageComponent extends AbstractBaseComponent {
  /**
   * An injectable service for handling JSON Web Token (JWT) operations.
   * Provides functionalities such as encoding, decoding, and verifying tokens.
   *
   * jwtService is typically used to manage authentication and secure communication
   * within an application by working with JWTs.
   */
  protected readonly jwtService = inject(JwtService);

  /**
   * A service instance that provides methods and properties to interact with and manage page-related data or functionalities.
   * The `pageService` variable is injected for dependency management and typically facilitates accessing shared application logic
   * related to page handling, such as retrieving page details, managing states, or triggering updates.
   *
   * Note: The injection mechanism suggests that this service instance is part of a dependency injection framework used in the application.
   */
  protected readonly pageService = inject(PAGE);

  constructor() {
    super();
  }
}
